{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "Maklum balas dan cadangan anda akan membantu kami menambah baik produk dan perkhidmatan kami.",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "Jika anda mempunyai isu teknikal atau sokongan, atau memerlukan bantuan segera, sila hubungi Pentadbir Laserfiche atau Pembekal Penyelesaian anda seperti yang ditunjukkan dalam perjanjian perkhidmatan anda.",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "Menemui sesuatu yang anda suka atau tidak suka? Beritahu kami mengenainya.",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "Adakah anda mempunyai idea untuk ciri baharu atau penambahbaikan? Kami tidak sabar untuk mendengarnya.",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "Sila jangan sertakan sebarang maklumat sulit atau peribadi dalam maklum balas anda",
  "TELL_US_ABOUT_EXPERIENCE": "Beritahu kami tentang pengalaman anda",
  "TELL_US_ABOUT_IDEA": "Beritahu kami tentang idea anda",
  "I_HAVE_FEEDBACK": "Saya mempunyai maklum balas",
  "I_HAVE_SUGGESTION": "Saya mempunyai cadangan",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "Anda boleh menghubungi saya tentang maklum balas ini",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "Jika anda ingin menyertai Panel Pelanggan kami,",
  "PLEASE_CLICK_HERE": "Sila klik di sini.",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "Imej melebihi saiz fail maksimum {0}.",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "Imej rosak atau dalam format yang tidak dikenali.",
  "ACCEPTED_FORMATS_ARE_0": "Format yang diterima ialah: {0}.",
  "IMAGE_NOT_ATTACHED": "Imej tidak dilampirkan.",
  "ATTACH_IMAGE": "Lampirkan Imej",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "Sila lampirkan hanya satu imej.",
  "TAGS": "Tanda-tanda",
  "ADD_TAGS": "Tambah tag",
  "ADD_MORE_TAGS": "Tambah lebih banyak tag",
  "NO_TAGS_AVAILABLE": "Tiada tag tersedia"
}
